export default {
      id: "plus-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }